import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import "./contact.css";
import { ReactComponent as SendSVG } from '@svgs/send.svg';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { validateForm } from './form_validation';
import { me } from '@data/me'

const Contact = () => {

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [project, setProject] = useState('');
    const [theme, setTheme] = useState('light');

    const form = useRef();

    const sendEmail = async (e) => {
        const formResponse = validateForm(name, email, project);
        if (formResponse.status) {
            e.preventDefault();

            toast.promise(
                emailjs.sendForm('service_628b4yk', 'template_jew3v0a', form.current, 'n-KPhzPMdl1bLVXTv'),
                {
                    pending: 'Sending email...',
                    success: formResponse.msg,
                    error: 'Email not sent. Please try again later.'
                }
            );
            setName('');
            setEmail('');
            setProject('');
        } else {
            toast.error(formResponse.msg);
        }
        setTheme(document.querySelector('body').getAttribute('data-theme') === 'dark' ? 'dark' : 'light');
    };


    return (
        <section className="contact section" id="contact">
            <h2 className="section__title">Get in touch</h2>
            <span className="section__subtitle">Contact Me</span>

            <div className="contact__container container grid">
                <div className="contact__content">
                    <h3 className="contact__title">Talk to me</h3>

                    <div className="contact__info">
                        <div className="contact__card">
                            <i className="bx bx-mail-send contact__card-icon"></i>

                            <h3 className="contact__card-title">Email</h3>
                            <span className="contact__card-data">{me.socialUsernames.email}</span>

                            <a href={me.socialLinks.email} target='_blank' rel="noreferrer" className="contact__button">Write me <i className="bx bx-right-arrow-alt contact__button-icon"></i></a>
                        </div>

                        <div className="contact__card">
                            <i className="bx bxl-whatsapp contact__card-icon"></i>

                            <h3 className="contact__card-title">Whatsapp</h3>
                            <span className="contact__card-data">{me.socialUsernames.whatsapp}</span>

                            <a href={me.socialLinks.whatsapp} target='_blank' rel="noreferrer" className="contact__button">Text me <i className="bx bx-right-arrow-alt contact__button-icon"></i></a>
                        </div>

                        <div className="contact__card">
                            <i className="bx bxl-linkedin contact__card-icon"></i>

                            <h3 className="contact__card-title">LinkedIn</h3>
                            <span className="contact__card-data">{me.socialUsernames.linkedin}</span>

                            <a href={me.socialLinks.linkedin} target='_blank' rel="noreferrer" className="contact__button">Connect with me <i className="bx bx-right-arrow-alt contact__button-icon"></i></a>
                        </div>
                    </div>
                </div>

                <div className="contact__content">
                    <h3 className="contact__title">Write me your project</h3>

                    <form ref={form} className="contact__form">
                        <div className="contact__form-div">
                            <label className="contact__form-tag">Name</label>
                            <input type="text" value={name} onChange={(e) => setName(e.target.value)} name="name" className="contact__form-input" placeholder="Insert your name" required />
                        </div>

                        <div className="contact__form-div">
                            <label className="contact__form-tag">Email</label>
                            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} name="email" className="contact__form-input" placeholder="Insert your email" required />
                        </div>

                        <div className="contact__form-div contact__form-area">
                            <label className="contact__form-tag">Project</label>
                            <textarea value={project} onChange={(e) => setProject(e.target.value)} name="project" id="" cols="30" rows="10" className="contact__form-input" placeholder="Write your project" required></textarea>
                        </div>

                        <button onClick={sendEmail} className="button button--flex">
                            Send Message
                            <SendSVG />
                        </button>
                        <ToastContainer theme={theme} />
                    </form>
                </div>
            </div>
        </section>
    );
};

export default Contact;